import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OverviewPriorityGroupDetailComponent } from './overview-priority-group-detail/overview-priority-group-detail.component';
import { ModalService } from '../../modal/modal.service';
import { DetailProjectService } from 'src/app/services/detail-project.service';

@Component({
  selector: 'fun-overview-priority-group-timeline',
  templateUrl: './overview-priority-group-timeline.component.html',
  styleUrls: ['./overview-priority-group-timeline.component.scss'],
})
export class OverviewPriorityGroupTimelineComponent implements OnInit {

  @Output() public bookInvestEvent = new EventEmitter<any>();
  @Output() public addressChangedEvent = new EventEmitter<void>();
  @Input() public detailProject;

  public stageActive = null;
  stageWithPriorityGroups: any;

  constructor(
    private modalService: ModalService,
    private detailProjectService: DetailProjectService,
    public chdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    const stages = this.detailProject?.postal_code_investment_stages;
    this.stageActive = stages?.find(
      (_, index) =>
        this.detailProjectService.getIfIsStageActive(index, this.detailProject)
    ) ?? null;
    this.stageWithPriorityGroups = stages?.find(
      (stage) =>
        stage.priority_groups
    ) ?? null;
    this.chdRef.detectChanges();
  }

  public isStageActive(index: number): boolean {
    return this.detailProjectService.getIfIsStageActive(index, this.detailProject);
  }

  public isStagePassed(index: number): boolean {
    return this.detailProjectService.isStagePassed(index, this.detailProject);
  }

  public hasUserPriorityGroup(stage: any): boolean {
    return this.detailProjectService.hasUserPriorityGroup(stage);
  }

  public allUserGroupsFull(stage: any): boolean {
    if (!stage?.priority_groups?.length) return false;
    const userGroups = stage.priority_groups.filter((pg: any) => pg.isEnabledForUser);
    return userGroups.length > 0 && userGroups.every((pg: any) => pg.isGroupObjetiveFull);
  }

  viewDetails(stage) {
    const params = { stage, detailProject: this.detailProject };
    this.modalService.showModal(OverviewPriorityGroupDetailComponent, params, '', '', true).subscribe((modal: any) => {
      modal.onClose().subscribe();
      modal.getChildComponent().subscribe((componentRef: OverviewPriorityGroupDetailComponent) => {
        componentRef.removeComponentEvent.subscribe(() => {
          modal.close();
        });
        componentRef.addressChangedEvent.subscribe(() => {
          this.addressChangedEvent.emit();
        });
      });
    });
  }

  bookInvestment() {
    this.bookInvestEvent.emit();
  }

}
